module.exports = {
	"id": "dk-admin/changePassword",
	"type": "object",
	"newPasswordEqualToConfirmPassword": true,
	"properties": {
		"old": {
			"type": "string",
			"minLength": 3
		},
		"newPassword": {
			"type": "string",
			"pattern": "^(?=.*?[A-Za-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{5,15}$",
			"minLength": 5
		},
		"confirm": {
			"type": "string",
			"pattern": "^(?=.*?[A-Za-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{5,15}$",
			"minLength": 5
		}
	},
	"required": [
		"old",
		"newPassword",
		"confirm"
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/app/common/schema/changePassword.json
// module id = 859
// module chunks = 0